import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import auth from '@/common/auth/auth';
import {isAdmin, methodToActionPermissions} from '@/common/auth/auth-helper';
import {getMatchingRole} from './components/role-templates';

export default function createColumns(showDeleteUserDialog, showResendEmailDialog) {
    return new ColumnSet({
        id: 'users-list',
        store,
        version: 5,
        defaultColumns: [
            {
                header: 'Name',
                type: 'link',
                value: (fields) => {
                    if (fields.firstName || fields.lastName) {
                        const fullName = `${fields.firstName || ''} ${fields.lastName || ''}`.trim();
                        if (fullName !== '') {
                            return fullName;
                        }
                    }
                    return `(${fields.id})`;
                },
                to: ({fields}) => ({
                    name: 'update-user',
                    params: {
                        id: fields.id,
                    },
                }),
                predicate: auth.$pages['update-user'].isAllowed,
                predicateOverride: {
                    type: 'text',
                },
                sortable: true,
                sticky: true,
            },
            {
                name: 'email',
                sortable: true,
            },
            {
                name: 'status',
                type: 'badge',
                sortable: true,
                map: BADGES_COLOR_MAP.status,
            },
            {
                header: 'Last Login',
                name: 'loginTime',
                sortable: true,
                type: 'datetime',
            },
            {
                name: 'createdTime',
                header: 'Creation Time',
                sortable: true,
                type: 'datetime',
            },
        ],
        otherColumns: [
            {
                name: 'id',
                style: {truncate: true},
                sortable: true,
            },
            {
                name: 'businessPhone',
                sortable: true,
            },
            {
                name: 'mobilePhone',
                sortable: true,
            },
            {
                name: 'permissions',
                type: 'badge',
                sortable: true,
                value: (obj) => {
                    if (isAdmin(obj.permissions)) {
                        return 'Full Access';
                    }
                    const list = methodToActionPermissions(obj.permissions);
                    const role = getMatchingRole(list);
                    if (role) {
                        return `role: ${role.label}`;
                    }
                    return Object.entries(list).map(
                        ([permission, action]) => `${permission}: ${action}`,
                    );
                },
            },
            {
                name: 'updatedTime',
                header: 'Last Update Time',
                sortable: true,
                type: 'datetime',
            },
        ],
        lockedColumns: [
            {
                header: 'Confirmation Email',
                type: 'button',
                style: {
                    label: 'Resend',
                },
                enabled: ({rowData}) => rowData.fields.status !== 'active',
                click: ({rowData, grid}) => {
                    showResendEmailDialog(rowData, grid);
                },
                predicate: auth.$pages['update-user'].isAllowed,
            },
            {
                header: false,
                type: 'button',
                style: {
                    preset: 'delete',
                    tooltip: 'delete',
                },
                click: ({rowData, grid}) => {
                    showDeleteUserDialog(rowData, grid);
                },
                predicate: auth.$pages['update-user'].isAllowed,
            },
        ],
    });
}
